import React, { useEffect, useState } from "react";
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import BlogSection from "../Cards/BlogSection";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import AdminSidebar from "../Side/AdminSidebar";
import AboutPublishers from "../Dashboards/AboutPublishers";

const Home = () => {
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once
        });
    }, []);

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Sidebar */}
            {admin ? <AdminSidebar /> : <Sidebar />}

            {/* Main Content */}
            <div className="flex-1 bg-gray-100">
                <div className="flex-1 flex flex-col">
                    <Topbar />

                    {/* Main Content */}
                    <main className="pt-[30px] px-4">
                        <div className="mt-6">
                            <AboutPublishers></AboutPublishers>
                            {/* <BlogSection /> */}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Home;